import _ from "lodash";
import { OAuthService } from "vue-components-library";

import { ILoginRequest, ILoginResponse } from "@/Login/services";
import { HttpClient, HttpErrorParser, setDefaultAuthorizationHeader } from "@/App/services";
import { reThrowError } from "@/App/services/HttpErrorParser";

export default {
  async loadGlobalAdminAgencies() {
    const { data } = await HttpClient.get({ path: "/emsAgencies" });
    return _.sortBy(data, agency => agency.name.toUpperCase());
  },

  async login(request: ILoginRequest): Promise<ILoginResponse> {
    try {
      const tokenResponse = await HttpClient.post({
        path: "/auth/signin",
        data: { ...request, twiageClient: "emsDashboard" },
        errorHandler: reThrowError
      });
      return this.resolveUserByToken(tokenResponse);
    } catch (error) {
      throw HttpErrorParser.parse(error);
    }
  },

  async resolveUserByToken(tokenResponse: any) {
    try {
      setDefaultAuthorizationHeader(tokenResponse.data.token);
      const user = await HttpClient.get({ path: "/users/me" }).then(({ data }) => data);
      return { authorizationToken: tokenResponse.data, user };
    } catch (error) {
      setDefaultAuthorizationHeader(null);
      throw HttpErrorParser.parse(error);
    }
  },

  async loginByToken(idToken: string) {
    try {
      const tokenResponse = await OAuthService.setSigninUrl("/auth/idfs")
        .setHttpClient(HttpClient)
        .loginByToken(idToken);

      return this.resolveUserByToken(tokenResponse);
    } catch (error) {
      throw HttpErrorParser.parse(error);
    }
  },

  async logout() {
    try {
      await HttpClient.post({ path: "/auth/signout" });
      setDefaultAuthorizationHeader(null);
    } catch (error) {
      throw HttpErrorParser.parse(error);
    }
  }
};
